// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@awc/App/Components/Common/XngZone";
import { XNGAGE_ELEMENTS } from "@awc/XDL/constants";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface AlliedUniversityNavigationContainerStyles {
    container?: InjectableCss;
}

export const alliedUniversityNavigationContainerStyles: AlliedUniversityNavigationContainerStyles = {};
const styles = alliedUniversityNavigationContainerStyles;
type Props = WidgetProps;

const AlliedUniversityNavigationContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <XngZone contentId={id} zoneName="image" hint="Zone for image" />
            <XngZone contentId={id} zoneName="filtersZone" hint="Zone for Filters" />
            <XngZone contentId={id} zoneName="NavigationLinks" hint="Zone for Navigation Links" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AlliedUniversityNavigationContainer,
    definition: {
        displayName: "Allied University Navigation Container",
        group: XNGAGE_ELEMENTS,
    },
};

export default widgetModule;
